import { GroupType } from "./group-type.mjs"

export const GROUP_SCHEDULES_FIELD_BY_TYPE = Object.freeze({
    [GroupType.ADD]: "addTypeSchedules",
    [GroupType.INTRODUCTION]: "introTypeSchedules",
})

export function getGroupSchedulesField(groupType) {
    return GROUP_SCHEDULES_FIELD_BY_TYPE[groupType] ?? null
}
